import { useCallback } from 'react'

import { useAddSnackbarQueue } from '../../../context/SnackbarContext'
import { useSectionInteraction } from './useSectionInteraction'

export const useSnackbarSectionInteraction = (initialConfirmedData = null, initialDraft = null) => {
    const addSnackbarQueue = useAddSnackbarQueue()
    const notifySuccess = useCallback(
        message => addSnackbarQueue(message, 'success'),
        [addSnackbarQueue],
    )

    return useSectionInteraction(initialConfirmedData, initialDraft, notifySuccess)
}
